import { IThemeMode } from "@/@types/types";
import { CommonConstants } from "@/common/constants";

export interface GameConfigType {
  id: number
  usdkId: number
  alias: number
  name: string
  title: string
  path: string
  email?: string // 邮箱地址
  isShowJapanAgreement?: boolean // 是否显示日本协议
  isShowKoreaAgreement?: boolean // 是否显示韩国协议
  isShowServer: boolean // 是否显示区服
  isShowAutoLogin: boolean
  isShowRoleIdLogin: boolean  // 是否打开角色ID登录
  wechatOuterUrlIOS: string[]
  wechatInnerUrlIOS?: string[]
  wechatOuterUrlAND: string[]
  isShowLangChange: boolean // 是否显示切换语言
  isShowCountryChange: boolean // 是否显示切换国家
  isShowHomeEntry: boolean // 是否在主页显示游戏入口
  isOpenCart: boolean // 是否开启购物车
  isOpenTelLogin?: boolean // 是否开启手机登录
  noShowLoginServer?: boolean // 登录时不显示区服选择
  kefuUrl?: string // 客服地址
  theme: IThemeMode
  kefuGameId?: number
  isShowJoinUs: boolean
  icon?: string
  apiBaseUrl?: string // 游戏独立的接口域名，不配置则使用环境变量 VUE_APP_API_BASE_URL
  isDisableBackHome?: boolean // 点击 header logo 是否禁止返回首页
}
export interface GAME_CARD_CONFIG_TYPE {
  [key: string]: GameConfigType
}

export const GAME_CARD_CONFIG: GAME_CARD_CONFIG_TYPE = {
  // ======================== 国内 ============================== //
  // 潘神
  '/dna': {
    id: 105,
    alias: 105,
    usdkId: 2277,
    kefuGameId: 2277,
    path: '/dna',
    email: '1',
    name: '二重螺旋-英雄游戏支付中心',
    title: '二重螺旋',
    icon: 'https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/topup-32.png',
    noShowLoginServer: false,
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.hero.dna.ios'],
    wechatInnerUrlIOS: ['https://dna.yingxiong.com/'],
    wechatOuterUrlAND: ['usdk-com.hero.dna.gf'],
    isShowHomeEntry: true,
    isOpenCart: false,
    isOpenTelLogin: true,
    isShowJoinUs: true,
    theme: 'light'
  },
  // U2 已下线
  // '/cnee': {
  //   id: 100,
  //   alias: 100,
  //   usdkId: 2174,
  //   kefuGameId: 2174,
  //   path: '/cnee',
  //   name: '星际52区-英雄游戏支付中心',
  //   email: '1',
  //   isShowServer: true,
  //   isShowLangChange: false,
  //   isShowCountryChange: false,
  //   isShowAutoLogin: false,
  //   isShowRoleIdLogin: true,
  //   wechatOuterUrlIOS: ['usdk-com.hero.rpg.xj52q'],
  //   wechatInnerUrlIOS: ['https://eecn.yingxiong.com/'],
  //   wechatOuterUrlAND: ['usdk-com.hero.idle.official.u2'],
  //   isShowHomeEntry: true,
  //   isOpenCart: false,
  //   isOpenTelLogin: true,
  //   theme: 'dark'
  // },
  // 国内创魔
  '/cncm': {
    id: 102,
    alias: 102,
    usdkId: 1016,
    kefuGameId: 126,
    path: '/cncm',
    name: '创造与魔法-英雄游戏支付中心',
    title: '创造与魔法',
    icon: 'https://cdn.yingxiong.com/file/1710308631787_35181885.png?1710308632658',
    email: '1',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: true,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.hero.sm.ios.hero'],
    wechatInnerUrlIOS: ['https://sm.yingxiong.com/'],
    wechatOuterUrlAND: [], // usdk-com.hero.sm.android.hero
    isOpenCart: true,
    isOpenTelLogin: true,
    isShowJoinUs: true,
    theme: 'light'
  },
  // 国内文明重启 王牌
  '/wpzz': {
    id: 103,
    alias: 103,
    usdkId: 1058,
    kefuGameId: 157,
    icon: 'https://cdn.yingxiong.com/file/1753854966921_16127662.png',
    path: '/wpzz',
    name: '文明重启-英雄游戏支付中心',
    title: '文明重启',
    email: '1',
    noShowLoginServer: true,
    isShowServer: false,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: true,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.lastdayrulessurvival.heroios'],
    wechatInnerUrlIOS: ['https://hero.yingxiong.com/'],
    wechatOuterUrlAND: [], // 'usdk-com.yingxiong.gw.Android.hero'
    isOpenCart: false,
    isOpenTelLogin: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  '/xxyz': {
    id: 107,
    alias: 107,
    usdkId: 2334,
    kefuGameId: 157,
    icon: 'https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/xxyz-logo.png',
    path: '/xxyz',
    name: '咻咻勇者-英雄游戏支付中心',
    title: '咻咻勇者',
    email: '1',
    noShowLoginServer: false,
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: false,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatInnerUrlIOS: [],
    wechatOuterUrlAND: [], // 'usdk-com.yingxiong.gw.Android.hero'
    isOpenCart: false,
    isOpenTelLogin: false,
    isShowJoinUs: true,
    theme: 'light',
    apiBaseUrl: 'https://shopbuyapi.zealshow.com/cnmall/api',
    isDisableBackHome: true
  },
  // 灵魂潮汐 已下线
  // '/lhcx': {
  //   id: 101,
  //   alias: 101,
  //   usdkId: 1124,
  //   path: '/lhcx',
  //   name: '灵魂潮汐-英雄游戏支付中心',
  //   isShowServer: true,
  //   isShowLangChange: false,
  //   isShowCountryChange: false,
  //   isShowHomeEntry: true,
  //   isShowAutoLogin: false,
  //   isShowRoleIdLogin: true,
  //   wechatOuterUrlIOS: ['com.glkj.lhcx.apple'],
  //   wechatInnerUrlIOS: ['https://lhcx.iqigame.net/'],
  //   wechatOuterUrlAND: ['com.glkj.lhcx.gf'],
  //   isOpenCart: false,
  //   isOpenTelLogin: true,
  //   theme: 'dark'
  // },
  // sample
  '/sampleInternal': {
    id: 104,
    alias: 104,
    usdkId: 100,
    kefuGameId: 2277,
    path: '/sampleInternal',
    name: 'sample-英雄游戏支付中心',
    title: 'sample',
    email: '1',
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatInnerUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isOpenTelLogin: true,
    isShowJoinUs: true,
    theme: 'light'
  },
  // ======================== 海外 ============================== //
  '/topup': {
    id: 13,
    alias: 13,
    usdkId: 2242,
    path: '/topup',
    email: 'dna_cs@dna-panstudio.com',
    name: 'DUET NIGHT ABYSS',
    title: 'DUET NIGHT ABYSS',
    isShowJapanAgreement: true,
    isShowKoreaAgreement: true,
    noShowLoginServer: false,
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: false,
    wechatOuterUrlIOS: [],
    wechatInnerUrlIOS: [],
    wechatOuterUrlAND: [],
    isShowHomeEntry: false,
    isOpenCart: false,
    isOpenTelLogin: false,
    isShowJoinUs: false,
    theme: 'dark',
    apiBaseUrl: "https://store.dna-panstudio.com/api",
    isDisableBackHome: true
  },
  '/ee': {
    id: 4,
    alias: 4,
    usdkId: 2222,
    path: '/ee',
    name: 'Eternal Evolution - Hero Games Store',
    title: 'Eternal Evolution',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: true,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.eternalevolution'],
    wechatOuterUrlAND: [
      'usdk-com.herogame.gplay.eternalevolution.idlerpg',
      'usdk-com.herogame.redtide2.huawei'
    ],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // U2 韩国
  '/kree': {
    id: 16,
    alias: 16,
    usdkId: 2327,
    path: '/kree',
    name: '이터널 에볼루션 - Hero Games Store',
    title: '이터널 에볼루션',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: true,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.eternalevolution.kr'],
    wechatOuterUrlAND: [
      'com.herogame.gp.eternalevolution.kr'
    ],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 枪4
  '/lios': {
    id: 6,
    alias: 6,
    usdkId: 2079,
    path: '/lios',
    name: 'Last Island Of Survival - Hero Games Store',
    title: 'Last Island Of Survival',
    email: 'lastdayrulessurvival@gmail.com',
    noShowLoginServer: true,
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.lastdayrules'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.lastdayrulessurvival'],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 枪4 light
  '/lioslite': {
    id: 9,
    alias: 9,
    usdkId: 2258,
    path: '/lioslite',
    name: 'Last Island Of Survival LITE - Hero Games Store',
    title: 'Last Island Of Survival LITE',
    email: 'lioslite@yingxiong.com',
    noShowLoginServer: true,
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.lastdayrules'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.survival.lite'],
    isOpenCart: false,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // u2 台湾  天演进化  // u2 海外
  '/twee': {
    id: 1,
    alias: 1,
    usdkId: 2066,
    path: '/twee',
    name: '天演進化 - Hero Games Store',
    title: '天演進化',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: true,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.redtide2'],
    wechatOuterUrlAND: [
      'usdk-com.herogame.gplay.eternalevolution.idlerpg',
      'usdk-com.herogame.redtide2.huawei'
    ],
    isOpenCart: false,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 乌托邦 台湾 (创魔)
  '/twwtb': {
    id: 3,
    alias: 3,
    usdkId: 2048,
    path: '/twwtb',
    name: '烏托邦：起源 - Hero Games Store',
    title: '烏托邦：起源',
    email: 'utopia@herogame.com',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.magicminecraft.survival.mmorpg'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.magicminecraft.mmorpg'],
    isOpenCart: false,
    isShowJoinUs: true,
    theme: 'light'
  },
  // 小龙2
  '/sd2': {
    id: 8,
    alias: 8,
    usdkId: 2261,
    path: '/sd2',
    name: 'Summon Dragons 2 - Hero Games Store',
    title: 'Summon Dragons 2',
    email: 'summondragons2@outlook.com',
    noShowLoginServer: true,
    isShowServer: false,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: ['usdk-com.herogame.ios.summondragons.two.idlerpg'],
    wechatOuterUrlAND: ['usdk-com.herogame.gplay.summondragons.two.idlerpg'],
    isOpenCart: false,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 三国志 日本
  '/shinsangokushi': {
    id: 11,
    alias: 11,
    usdkId: 2301, //  2272 测试
    path: '/shinsangokushi',
    name: '新三國志 - Hero Games Store',
    title: '新三國志',
    email: 'cs@shinsangokushi.com',
    isShowJapanAgreement: true,
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 三国志 日本
  '/shinsangokushinew': {
    id: 11,
    alias: 11,
    usdkId: 2301, //  2272 测试
    path: '/shinsangokushinew',
    name: '新三國志 - Hero Games Store',
    title: '新三國志',
    email: 'cs@shinsangokushi.com',
    isShowJapanAgreement: true,
    isShowServer: true,
    isShowLangChange: false,
    isShowCountryChange: false,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  // 星球海外 下架 2025-1-15 14:52
  // '/auroria': {
  //   id: 12,
  //   alias: 12,
  //   usdkId: 2307,
  //   path: '/auroria',
  //   name: 'Auroria - Hero Games Store',
  //   title: 'Auroria',
  //   isShowServer: true,
  //   isShowLangChange: true,
  //   isShowCountryChange: true,
  //   isShowHomeEntry: true,
  //   isShowAutoLogin: false,
  //   isShowRoleIdLogin: true,
  //   wechatOuterUrlIOS: [], // 'usdk-com.herogame.projectstars'
  //   wechatOuterUrlAND: ['usdk-com.herogame.gplay.outerland.auroria.survivalminecraft.mmorpg'],
  //   isOpenCart: false,
  //   isShowJoinUs: true,
  //   theme: 'dark'
  // },
  // 信长
  '/nobunaga': {
    id: 14,
    alias: 14,
    usdkId: 2314,
    path: '/nobunaga',
    name: '信长天下布武 - Hero Games Store',
    title: '信长天下布武',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  },
  '/sampleglobal': {
    id: 5,
    alias: 5,
    usdkId: 1111,
    path: '/sampleglobal',
    name: 'Sample',
    title: 'Sample',
    email: 'cs@shinsangokushi.com',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'light'
  },
  // 机械起源
  '/titanite': {
    id: 15,
    alias: 15,
    usdkId: 2252,
    path: '/titanite',
    name: 'Titanite - Hero Games Store',
    title: 'Titanite',
    isShowServer: true,
    isShowLangChange: true,
    isShowCountryChange: true,
    isShowHomeEntry: true,
    isShowAutoLogin: false,
    isShowRoleIdLogin: true,
    wechatOuterUrlIOS: [],
    wechatOuterUrlAND: [],
    isOpenCart: true,
    isShowJoinUs: true,
    theme: 'dark'
  }
}

// 获取当前游戏配置
export const getGameConfigById = (alias: string) => {
  return GAME_CARD_CONFIG[alias] || {}
}

// 根据游戏ID获取游戏路径
export const getGamePathById = (gameId: number): string => {
  for (const path in GAME_CARD_CONFIG) {
    if (GAME_CARD_CONFIG[path].id === gameId) {
      return path
    }
  }
  return ''
}

const cnRouteConfig = [
  '/cncm',
  '/wpzz',
  '/dna',
  '/xxyz',
  '/sampleInternal',
]

const globalRouteConfig = [
  '/lios',
  '/ee',
  '/twee',
  '/twwtb',
  '/dhtw',
  '/sd2',
  '/lioslite',
  '/sampleglobal',
  '/shinsangokushi',
  '/shinsangokushinew',
  // '/auroria',
  '/topup',
  '/nobunaga',
  '/kree',
  '/titanite'
]

export const getAllowRoute = () => {
  const RouteConfig = CommonConstants.IS_AREA === 'cn' ? cnRouteConfig : globalRouteConfig
  const env = process.env.VUE_APP_GAME
  const routeFilterMap: Record<string, string[]> = {
    'dnaGlobal': ['/topup']
  }
  if (env && routeFilterMap[env]) {
    return RouteConfig.filter(item => routeFilterMap[env].includes(item))
  }
  return RouteConfig
}

// 游戏关联的pcode   '/lhcx': 10160 下架
export const GAME_PCODE_CONFIG = {
  '/cnee': 17234,
  '/cncm': 10031,
  '/wpzz': 10084
} as { [k: string]: number }

// 海外商品类型
export const GOODS_TYPE_NAME = {
  1: 'i18n-token',
  2: 'i18n-gift-pack',
  3: 'i18n-subscribe',
  4: 'i18n-welfare'
}

// 只显示日语的游戏
export const ONLY_SHOW_JAPAN = ['/shinsangokushinew', '/shinsangokushi']

// 不允许购买的游戏
export const NOT_ALLOWED_BUY_PC = ['/cncm']

// 显示版权信息的游戏
export const SHOW_FOOTER_TEXT = [12, 3, 9, 6, 4]